/** Small state marks: check, close, plus, info, restart, menu, globe. */
import { IconBase, type IconProps } from "./Icon";

export function IconCheck(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M4.5 12.5l5 5L19.5 7" />
    </IconBase>
  );
}

export function IconClose(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M6 6l12 12M18 6L6 18" />
    </IconBase>
  );
}

export function IconMenu(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M4 7.5h16M4 12h16M4 16.5h16" />
    </IconBase>
  );
}

export function IconPlus(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M12 5v14M5 12h14" />
    </IconBase>
  );
}

export function IconInfo(props: IconProps) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 11v5" />
      <path d="M12 8v.01" strokeWidth={2} />
    </IconBase>
  );
}

export function IconRestart(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M5 12a7 7 0 1 0 2-4.9" />
      <path d="M7 3v4.3h4.3" />
    </IconBase>
  );
}

export function IconGlobe(props: IconProps) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17M12 3.5c-2.5 2.3-3.8 5.2-3.8 8.5s1.3 6.2 3.8 8.5c2.5-2.3 3.8-5.2 3.8-8.5s-1.3-6.2-3.8-8.5Z" />
    </IconBase>
  );
}
